import { FooterMark } from "./FooterMark";
import { Link } from "react-router-dom";
import { Instagram, Send } from "lucide-react";

const A = "hover:text-[#ECEBE4] transition-colors duration-300";
const COLS = [
  ["Terminal", [
    ["Open free terminal", "https://alpha.tradrquant.com", "footer-free-terminal-link", true],
    ["TradingView indicator", "https://www.tradingview.com/script/MiXDrieo-TradrQuant-Pro/", "footer-tv-indicator-link", true],
    ["Order flow terminal", "https://alpha.tradrquant.com/terminal", "footer-of-terminal-link", true],
    ["Order flow features", "/order-flow", "footer-order-flow-link"],
    ["Flow Cells · whale rotation map", "/flow-cells-whale-rotation-map", "footer-flow-cells-link"],
    ["Exchange data · Hyperliquid, Binance, OKX", "/data/hyperliquid-binance-okx-order-flow", "footer-exchange-data-link"],
    ["TQ Pulse screener", "https://alpha.tradrquant.com/screener", "footer-pulse-link", true],
    ["Whale Radar", "https://alpha.tradrquant.com/whales", "footer-whales-link", true],
    ["Terminal modules", "/terminal", "footer-terminal-modules-link"],
    ["Signal scanner", "/terminal#signal-scanner", "footer-scanner-link"],
    ["Pattern engine", "/terminal/pattern-scanner"],
    ["Screener heat grid", "/terminal/screener-heat-grid"],
    ["Founder pricing", "/#access", "footer-pricing-link", true],
    ["Terminal tour · video", "/terminal#terminal-tour", "footer-tour-link"],
  ]],
  ["Research & learn", [
    ["Quant Lab · Research", "/research", "footer-research-link"],
    ["Academy · Education", "/learn", "footer-academy-link"],
    ["Pro Indicator · Docs", "/tools/tradrquant-pro-indicator", "footer-indicator-docs-link"],
    ["Compare", "/compare", "footer-compare-link"],
  ]],
  ["Company", [
    ["About us", "/about", "footer-about-link"],
    ["Founder", "/about", "footer-founder-link"],
    ["Track record · Verify", "https://verify.tradrquant.com", "footer-verify-link", true],
    ["Referral program", "/referral", "footer-referral-link"],
    ["Telegram", "https://t.me/TradrQuantRadar", "footer-telegram-link", true],
    ["Instagram", "https://www.instagram.com/tradrquant/", "footer-instagram-link", true],
  ]],
  ["Legal", [
    ["Terms", "/terms", "footer-terms-link"],
    ["Risk notice", "/risk", "footer-risk-link"],
    ["Privacy", "/privacy", "footer-privacy-link"],
  ]],
];

const FLink = ([label, href, tid, ext]) =>
  ext || href.includes("#") ? (
    <a href={href} data-testid={tid} className={A}>{label}</a>
  ) : (
    <Link to={href} data-testid={tid} className={A}>{label}</Link>
  );

export const Footer = () => (
  <footer data-testid="site-footer" className="relative overflow-hidden border-t border-white/[0.07] bg-[#08090B]">
    <div className="mx-auto max-w-[1400px] px-6 pb-10 pt-16 md:px-12">
      <div className="grid gap-12 lg:grid-cols-[1.2fr_2.4fr]">
        <div className="max-w-sm">
          <div className="flex items-center gap-2.5">
            <img src="/tq-logo.png?v=3" alt="TradrQuant" className="h-6 w-auto" />
            <span className="tq-wordmark text-[#ECEBE4] text-[21px]">Tradr<span className="tq-q">Q</span>uant</span>
          </div>
          <p className="mt-5 text-[15px] leading-relaxed text-[#7D8390]">
            The institutional market-intelligence terminal, built for retail. Trade setups, order flow, market pulse, deep research and breaking news. Every claim verified.
          </p>
          <p className="mt-5 font-mono text-[11px] uppercase tracking-[0.18em] text-[#5A6170]">JC Rod · @Tradernaut · Founder</p>
          <div className="mt-6 flex gap-2">
            {[["instagram", "https://www.instagram.com/tradrquant/", Instagram], ["telegram", "https://t.me/TradrQuantRadar", Send]].map(([id, href, Icon]) => (
              <a key={id} href={href} target="_blank" rel="noreferrer" aria-label={id} data-testid={`footer-social-${id}`} className="inline-flex h-9 w-9 items-center justify-center border border-white/[0.10] text-[#9DA3AE] transition-colors hover:border-white/30 hover:text-[#ECEBE4]">
                <Icon size={15} />
              </a>
            ))}
          </div>
        </div>
        <div className="grid grid-cols-2 gap-10 sm:grid-cols-4">
          {COLS.map(([title, links]) => (
            <div key={title}>
              <p className="mb-5 font-mono text-[10px] uppercase tracking-[0.22em] text-[#5A6170]">{title}</p>
              <ul className="space-y-3 text-sm text-[#9DA3AE]">
                {links.map((l) => <li key={l[0]}>{FLink(l)}</li>)}
              </ul>
            </div>
          ))}
        </div>
      </div>
      <div className="mt-14 flex flex-col justify-between gap-4 border-t border-white/[0.07] pt-8 font-mono text-[10px] uppercase tracking-[0.2em] text-[#5A6170] sm:flex-row">
        <span className="flex items-center gap-2">
          © {new Date().getFullYear()} TradrQuant · Quantify the market · Capture the edge
          <Link to="/admin/analytics" data-testid="footer-admin-link" aria-label="Traffic dashboard" title="Traffic dashboard" className="text-sm leading-none text-white/20 no-underline transition-colors duration-300 hover:text-[#ECEBE4]">•</Link>
        </span>
        <span>This isn't financial advice · Research and education only</span>
      </div>
      <FooterMark haze />
    </div>
  </footer>
);
